import React from 'react';

const ServiceSelector = ({ selectedService, onServiceChange, services }) => {
  return (
    <div className="mb-6">
      <p className="font-semibold text-gray-700 mb-3">Chọn dịch vụ bạn quan tâm:</p>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {Object.entries(services).map(([key, service]) => (
          <div key={key}>
            <input
              type="radio"
              name="service"
              id={`service-${key}`}
              value={key}
              checked={selectedService === key}
              onChange={(e) => onServiceChange(e.target.value)}
              className="hidden"
            />
            <label
              htmlFor={`service-${key}`}
              className={`cursor-pointer w-full flex flex-col items-center justify-center p-4 border-2 rounded-2xl font-semibold transition-all ${selectedService === key
                ? 'bg-primary-500 text-white border-primary-500 shadow-primary'
                : 'text-primary-600 border-primary-200 hover:border-primary-400 hover:shadow-primary'
                }`}
            >
              <span className="text-3xl mb-2">{service.icon}</span>
              <span className="text-sm text-center leading-tight">{service.label}</span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceSelector;